import { useState, useEffect } from "react";

// Utils
import { formatUserFriendlyDate } from "utils/date.utils";

// Styles
import VotingSessionFilterContainer from "./VotingSessionFilter.styles";
import Select from "components/Common/Select/Select";

type Props = {
    setSelectedDateSession: (sessionId: string) => void;
    allCompanySessions: any;
    gotCompanySessions: boolean;
    currentSessionId: string;
};

const VotingSessionFilter = ({
    setSelectedDateSession,
    allCompanySessions,
    gotCompanySessions,
    currentSessionId,
}: Props) => {
    const [companySessions, setCompanySessions] = useState<any>(null);
    const [sessionDates, setSessionDates] = useState<Record<string, string>>(
        {}
    );
    const [loadingSessionDates, setLoadingSessionDates] =
        useState<boolean>(false);

    useEffect(() => {
        setCompanySessions(allCompanySessions);
    }, [gotCompanySessions]);

    useEffect(() => {
        if (!companySessions) return;

        const dates: Record<string, string> = { "": "Latest Session" };
        companySessions.data.forEach((session: any) => {
            dates[session.id] =
                "Session on " + formatUserFriendlyDate(session.date);
        });

        setSessionDates(dates);
        setLoadingSessionDates(true);

        if (currentSessionId && !(currentSessionId in dates)) {
            setSelectedDateSession("");
        }
    }, [companySessions]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <VotingSessionFilterContainer className="votingSessionDate">
            {loadingSessionDates && (
                <div>
                    <div className={"session-selector"}>
                        <Select
                            filterName="Latest Session"
                            showAll={false}
                            value={currentSessionId}
                            setValue={setSelectedDateSession}
                            options={Object.entries(sessionDates).map(
                                ([sessionId, date]) => ({
                                    value: sessionId,
                                    label: date,
                                })
                            )}
                        />
                    </div>
                </div>
            )}
        </VotingSessionFilterContainer>
    );
};

export default VotingSessionFilter;
